"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAllegroHeader = parseAllegroHeader;
exports.parseAllegroFile = parseAllegroFile;
const blockStructs_1 = require("./blockStructs");
const formatVersion_1 = require("./formatVersion");
const stream_1 = require("./stream");
function readLL(stream, ver = formatVersion_1.AllegroFormatVersion.V_160) {
    const w1 = stream.readU32();
    const w2 = stream.readU32();
    if (ver >= formatVersion_1.AllegroFormatVersion.V_180) {
        return { tail: w2, head: w1 };
    }
    return { tail: w1, head: w2 };
}
function readLayerInfo(stream) {
    const classCode = stream.readU8();
    const subclassCode = stream.readU8();
    return { classCode, subclassCode };
}
function readTextProps(stream) {
    const key = stream.readU8();
    const flags = stream.readU8();
    const alignmentByte = stream.readU8();
    let alignment;
    switch (alignmentByte) {
        case 0x01:
            alignment = blockStructs_1.AllegroTextAlignment.LEFT;
            break;
        case 0x02:
            alignment = blockStructs_1.AllegroTextAlignment.RIGHT;
            break;
        case 0x03:
            alignment = blockStructs_1.AllegroTextAlignment.CENTER;
            break;
        default:
            alignment = blockStructs_1.AllegroTextAlignment.UNKNOWN;
            break;
    }
    const reversalByte = stream.readU8();
    let reversal;
    switch (reversalByte) {
        case 0x00:
            reversal = blockStructs_1.TextReversal.STRAIGHT;
            break;
        case 0x01:
            reversal = blockStructs_1.TextReversal.REVERSED;
            break;
        default:
            reversal = blockStructs_1.TextReversal.UNKNOWN;
            break;
    }
    return { key, flags, alignment, reversal };
}
function readCondU32(stream, ver, minVer) {
    if ((0, blockStructs_1.condExists)(ver, minVer)) {
        return stream.readU32();
    }
    return undefined;
}
function readCondU16(stream, ver, minVer) {
    if ((0, blockStructs_1.condExists)(ver, minVer)) {
        return stream.readU16();
    }
    return undefined;
}
function readCondU32Lt(stream, ver, maxVer) {
    if ((0, blockStructs_1.condExistsLt)(ver, maxVer)) {
        return stream.readU32();
    }
    return undefined;
}
function readCondU16Lt(stream, ver, maxVer) {
    if ((0, blockStructs_1.condExistsLt)(ver, maxVer)) {
        return stream.readU16();
    }
    return undefined;
}
function readCondArrayU32(stream, ver, minVer, count) {
    if ((0, blockStructs_1.condExists)(ver, minVer)) {
        return stream.readArrayU32(count);
    }
    return undefined;
}
function readCondArrayU32Lt(stream, ver, maxVer, count) {
    if ((0, blockStructs_1.condExistsLt)(ver, maxVer)) {
        return stream.readArrayU32(count);
    }
    return undefined;
}
function readCondArrayU32Range(stream, ver, minVer, maxVer, count) {
    if ((0, blockStructs_1.condExistsRange)(ver, minVer, maxVer)) {
        return stream.readArrayU32(count);
    }
    return undefined;
}
function parseBlock0x01Arc(stream, ver, offset) {
    stream.skip(1);
    const unknownByte = stream.readU8();
    const subType = stream.readU8();
    const key = stream.readU32();
    const next = stream.readU32();
    const parent = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown6 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const width = stream.readU32();
    const startX = stream.readS32();
    const startY = stream.readS32();
    const endX = stream.readS32();
    const endY = stream.readS32();
    const centerX = stream.readAllegroFloat();
    const centerY = stream.readAllegroFloat();
    const radius = stream.readAllegroFloat();
    const boundingBoxCoords = stream.readArrayS32(4);
    return {
        blockType: 0x01,
        offset,
        unknownByte,
        subType,
        key,
        next,
        parent,
        unknown1,
        unknown6,
        width,
        startX,
        startY,
        endX,
        endY,
        centerX,
        centerY,
        radius,
        boundingBoxCoords,
    };
}
function parseBlock0x03Field(stream, ver, offset) {
    stream.skip(1);
    const hdr1 = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const subType = stream.readU8();
    const hdr2 = stream.readU8();
    const size = stream.readU16();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    let substruct;
    switch (subType) {
        case 0x65:
            break;
        case 0x64:
        case 0x66:
        case 0x67:
        case 0x6a:
            substruct = { type: "u32", value: stream.readU32() };
            break;
        case 0x69:
            substruct = { type: "u32x2", values: [stream.readU32(), stream.readU32()] };
            break;
        case 0x68:
        case 0x6b:
        case 0x6d:
        case 0x6e:
        case 0x6f:
        case 0x71:
        case 0x73:
        case 0x78:
            substruct = { type: "string", value: stream.readStringFixed(size, true) };
            break;
        case 0x6c: {
            const numEntries = stream.readU32();
            if (numEntries > 1000000) {
                throw new Error(`Block 0x03 subtype 0x6C entry count ${numEntries} exceeds limit at offset 0x${stream
                    .position()
                    .toString(16)}`);
            }
            const entries = [];
            for (let i = 0; i < numEntries; i++) {
                entries.push(stream.readU32());
            }
            substruct = { type: "0x6C", numEntries, entries };
            break;
        }
        case 0x70:
        case 0x74: {
            const x0 = stream.readU16();
            const x1 = stream.readU16();
            const numEntries = x1 + 4 * x0;
            const entries = [];
            for (let i = 0; i < numEntries; i++) {
                entries.push(stream.readU8());
            }
            substruct = { type: "0x70_0x74", x0, x1, entries };
            break;
        }
        case 0xf6: {
            const entries = stream.readArrayU32(4);
            substruct = { type: "0xF6", entries };
            break;
        }
        default:
            if (size === 4) {
                substruct = { type: "u32", value: stream.readU32() };
            }
            else if (size === 8) {
                substruct = { type: "u32x2", values: [stream.readU32(), stream.readU32()] };
            }
            else {
                throw new Error(`Unknown substruct type 0x${subType.toString(16)} with size ${size}`);
            }
            break;
    }
    return { blockType: 0x03, offset, hdr1, key, next, unknown1, subType, hdr2, size, unknown2, substruct };
}
function parseBlock0x04NetAssignment(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const net = stream.readU32();
    const connItem = stream.readU32();
    const unknown = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return { blockType: 0x04, offset, type, r, key, next, net, connItem, unknown };
}
function parseBlock0x05Track(stream, ver, offset) {
    stream.skip(1);
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const netAssignment = stream.readU32();
    const unknownPtr1 = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = stream.readU32();
    const unknownPtr2a = stream.readU32();
    const unknownPtr2b = stream.readU32();
    const unknown4 = stream.readU32();
    const unknownPtr3a = stream.readU32();
    const unknownPtr3b = stream.readU32();
    const unknown5a = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown5b = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const firstSegPtr = stream.readU32();
    const unknownPtr5 = stream.readU32();
    const unknown6 = stream.readU32();
    return {
        blockType: 0x05,
        offset,
        layer,
        key,
        next,
        netAssignment,
        unknownPtr1,
        unknown2,
        unknown3,
        unknownPtr2a,
        unknownPtr2b,
        unknown4,
        unknownPtr3a,
        unknownPtr3b,
        unknown5a,
        unknown5b,
        firstSegPtr,
        unknownPtr5,
        unknown6,
    };
}
function parseBlock0x06Component(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const compDeviceType = stream.readU32();
    const symbolName = stream.readU32();
    const firstInstPtr = stream.readU32();
    const ptrFunctionSlot = stream.readU32();
    const ptrPinNumber = stream.readU32();
    const fields = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x06,
        offset,
        key,
        next,
        compDeviceType,
        symbolName,
        firstInstPtr,
        ptrFunctionSlot,
        ptrPinNumber,
        fields,
        unknown1,
    };
}
function parseBlock0x07ComponentInst(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknownPtr1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const fpInstPtr = stream.readU32();
    const unknown4 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const refDesStrPtr = stream.readU32();
    const functionInstPtr = stream.readU32();
    const x03Ptr = stream.readU32();
    const unknown5 = stream.readU32();
    const firstPadPtr = stream.readU32();
    return {
        blockType: 0x07,
        offset,
        key,
        next,
        unknownPtr1,
        unknown2,
        unknown3,
        fpInstPtr,
        unknown4,
        refDesStrPtr,
        functionInstPtr,
        x03Ptr,
        unknown5,
        firstPadPtr,
    };
}
function parseBlock0x08PinNumber(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const previous = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const strPtr16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const next = stream.readU32();
    const strPtr = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const pinNamePtr = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const ptr4 = stream.readU32();
    return { blockType: 0x08, offset, type, r, key, previous, strPtr16x, next, strPtr, pinNamePtr, unknown1, ptr4 };
}
function parseBlock0x09FillLink(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const unknownArray = stream.readArrayU32(3);
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknownPtr1 = stream.readU32();
    const unknownPtr2 = stream.readU32();
    const unknown2 = stream.readU32();
    const unknownPtr3 = stream.readU32();
    const unknownPtr4 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x09,
        offset,
        key,
        unknownArray,
        unknown1,
        unknownPtr1,
        unknownPtr2,
        unknown2,
        unknownPtr3,
        unknownPtr4,
        unknown3,
    };
}
function parseBlock0x0ADrc(stream, ver, offset) {
    const t = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coords = stream.readArrayS32(4);
    const unknown4 = stream.readArrayU32(3);
    const unknown5 = stream.readArrayU32(2);
    const unknown6 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return { blockType: 0x0a, offset, t, layer, key, next, unknown1, unknown2, coords, unknown4, unknown5, unknown6 };
}
function parseBlock0x0CPinDef(stream, ver, offset) {
    const t = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = stream.readU32();
    const shape = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const drillChar = readCondU16(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknownPadding = readCondU16(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const shape16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const drillChars = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown4 = stream.readU32();
    const coords = stream.readArrayS32(4);
    const size = stream.readArrayS32(2);
    const unknownArray = stream.readArrayU32(4);
    const unknown6 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x0c,
        offset,
        t,
        layer,
        key,
        next,
        unknown1,
        unknown2,
        shape,
        drillChar,
        unknownPadding,
        shape16x,
        drillChars,
        unknown16x,
        unknown4,
        coords,
        size,
        unknownArray,
        unknown6,
    };
}
function parseBlock0x0DPad(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const nameStrId = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coordsX = stream.readS32();
    const coordsY = stream.readS32();
    const padStack = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const flags = stream.readU32();
    const rotation = stream.readU32();
    return {
        blockType: 0x0d,
        offset,
        key,
        nameStrId,
        next,
        unknown1,
        coordsX,
        coordsY,
        padStack,
        unknown2,
        unknown3,
        flags,
        rotation,
    };
}
function parseBlock0x0EShapeSeg(stream, ver, offset) {
    const t = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const fpPtr = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = stream.readU32();
    const unknown4 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown5 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coords = stream.readArrayS32(4);
    const unknownArr = stream.readArrayU32(3);
    return {
        blockType: 0x0e,
        offset,
        t,
        t2,
        key,
        next,
        fpPtr,
        unknown1,
        unknown2,
        unknown3,
        unknown4,
        unknown5,
        coords,
        unknownArr,
    };
}
function parseBlock0x0FFunctionSlot(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const slotName = stream.readU32();
    const compDeviceType = stream.readStringFixed(32, true);
    const ptr0x06 = stream.readU32();
    const ptr0x11 = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x0f, offset, key, slotName, compDeviceType, ptr0x06, ptr0x11, unknown1, unknown2, unknown3 };
}
function parseBlock0x10FunctionInst(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const componentInstPtr = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const ptrX12 = stream.readU32();
    const unknown3 = stream.readU32();
    const functionName = stream.readU32();
    const slots = stream.readU32();
    const fields = stream.readU32();
    return {
        blockType: 0x10,
        offset,
        key,
        unknown1,
        componentInstPtr,
        unknown2,
        ptrX12,
        unknown3,
        functionName,
        slots,
        fields,
    };
}
function parseBlock0x11PinName(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const pinNameStrPtr = stream.readU32();
    const next = stream.readU32();
    const pinNumberPtr = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return { blockType: 0x11, offset, type, r, key, pinNameStrPtr, next, pinNumberPtr, unknown1, unknown2 };
}
function parseBlock0x12Xref(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const ptr1 = stream.readU32();
    const ptr2 = stream.readU32();
    const ptr3 = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x12, offset, type, r, key, ptr1, ptr2, ptr3, unknown1, unknown2, unknown3 };
}
function parseBlock0x14Graphic(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const parent = stream.readU32();
    const flags = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const segmentPtr = stream.readU32();
    const ptr0x03 = stream.readU32();
    const ptr0x26 = stream.readU32();
    return { blockType: 0x14, offset, type, layer, key, next, parent, flags, unknown2, segmentPtr, ptr0x03, ptr0x26 };
}
function parseBlock0x15_16_17Segment(stream, ver, offset, segmentType) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const parent = stream.readU32();
    const flags = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const width = stream.readU32();
    const startX = stream.readS32();
    const startY = stream.readS32();
    const endX = stream.readS32();
    const endY = stream.readS32();
    return {
        blockType: segmentType,
        offset,
        segmentType,
        key,
        next,
        parent,
        flags,
        unknown2,
        width,
        startX,
        startY,
        endX,
        endY,
    };
}
function parseBlock0x1BNet(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const netName = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const type = stream.readU32();
    const assignment = stream.readU32();
    const ratline = stream.readU32();
    const fieldsPtr = stream.readU32();
    const matchGroupPtr = stream.readU32();
    const modelPtr = stream.readU32();
    const unknownPtr4 = stream.readU32();
    const unknownPtr5 = stream.readU32();
    const unknownPtr6 = stream.readU32();
    return {
        blockType: 0x1b,
        offset,
        key,
        next,
        netName,
        unknown1,
        unknown2,
        type,
        assignment,
        ratline,
        fieldsPtr,
        matchGroupPtr,
        modelPtr,
        unknownPtr4,
        unknownPtr5,
        unknownPtr6,
    };
}
function parseBlock0x1CPadstack(stream, ver, offset) {
    const unknownByte1 = stream.readU8();
    const n = stream.readU8();
    const unknownByte2 = stream.readU8();
    const key = stream.readU32();
    const next = stream.readU32();
    const padStr = stream.readU32();
    const drill = stream.readU32();
    const unknown2 = stream.readU32();
    const padPath = stream.readU32();
    const unknown3 = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown4 = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown5 = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown6 = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const t = stream.readU8();
    // eslint-disable-next-line no-bitwise
    const padTypeNibble = (t & 0xf0) >> 4;
    let padType;
    switch (padTypeNibble) {
        case 0x00:
            padType = blockStructs_1.AllegroPadType.THROUGH_VIA;
            break;
        case 0x01:
            padType = blockStructs_1.AllegroPadType.VIA;
            break;
        case 0x02:
        case 0x0a:
            padType = blockStructs_1.AllegroPadType.SMD_PIN;
            break;
        case 0x03:
            padType = blockStructs_1.AllegroPadType.SLOT;
            break;
        case 0x08:
            padType = blockStructs_1.AllegroPadType.NPTH;
            break;
        default:
            throw new Error(`Unknown padstack type 0x${t.toString(16)}`);
    }
    // eslint-disable-next-line no-bitwise
    const a = t & 0x0f;
    const b = stream.readU8();
    const c = stream.readU8();
    const d = stream.readU8();
    const unknown7 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown8 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown9 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown10 = readCondU16Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const layerCount = stream.readU16();
    if (layerCount > 256) {
        throw new Error(`Padstack layer count ${layerCount} exceeds maximum at offset 0x${stream.position().toString(16)}`);
    }
    const unknown11 = readCondU16(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const drillArr = stream.readArrayU32(8);
    const slotAndUnknownArr = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172, 28);
    const unknownArr8_2 = readCondArrayU32Range(stream, ver, formatVersion_1.AllegroFormatVersion.V_165, formatVersion_1.AllegroFormatVersion.V_172, 8);
    const v180Trailer = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_180, 8);
    const numFixedCompEntries = ver < formatVersion_1.AllegroFormatVersion.V_172 ? 10 : 21;
    const numCompsPerLayer = ver < formatVersion_1.AllegroFormatVersion.V_172 ? 3 : 4;
    const nComps = numFixedCompEntries + layerCount * numCompsPerLayer;
    const components = [];
    for (let i = 0; i < nComps; i++) {
        const compType = stream.readU8();
        const compUnknownByte1 = stream.readU8();
        const compUnknownByte2 = stream.readU8();
        const compUnknownByte3 = stream.readU8();
        const compUnknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
        const w = stream.readS32();
        const h = stream.readS32();
        const z1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
        const x3 = stream.readS32();
        const x4 = stream.readS32();
        const z = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
        const strPtr = stream.readU32();
        let z2;
        if (!(ver < formatVersion_1.AllegroFormatVersion.V_172 && i === nComps - 1)) {
            z2 = stream.readU32();
        }
        components.push({
            type: compType,
            unknownByte1: compUnknownByte1,
            unknownByte2: compUnknownByte2,
            unknownByte3: compUnknownByte3,
            unknown1: compUnknown1,
            w,
            h,
            z1,
            x3,
            x4,
            z,
            strPtr,
            z2,
        });
    }
    const nElems = n * (ver < formatVersion_1.AllegroFormatVersion.V_172 ? 8 : 10);
    const unknownArrN = [];
    for (let i = 0; i < nElems; i++) {
        unknownArrN.push(stream.readU32());
    }
    return {
        blockType: 0x1c,
        offset,
        unknownByte1,
        n,
        unknownByte2,
        key,
        next,
        padStr,
        drill,
        unknown2,
        padPath,
        unknown3,
        unknown4,
        unknown5,
        unknown6,
        padType,
        a,
        b,
        c,
        d,
        unknown7,
        unknown8,
        unknown9,
        unknown10,
        layerCount,
        unknown11,
        drillArr,
        slotAndUnknownArr,
        unknownArr8_2,
        v180Trailer,
        components,
        numFixedCompEntries,
        numCompsPerLayer,
        unknownArrN,
    };
}
function parseBlock0x1DConstraintSet(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const nameStrKey = stream.readU32();
    const fieldPtr = stream.readU32();
    const sizeA = stream.readU16();
    const sizeB = stream.readU16();
    const dataB = [];
    for (let i = 0; i < sizeB; i++) {
        dataB.push(stream.readBytes(56));
    }
    const dataA = [];
    for (let i = 0; i < sizeA; i++) {
        dataA.push(stream.readBytes(256));
    }
    const unknown4 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return { blockType: 0x1d, offset, key, next, nameStrKey, fieldPtr, sizeA, sizeB, dataB, dataA, unknown4 };
}
function parseBlock0x1ESiModel(stream, ver, offset) {
    const type = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown2 = readCondU16(stream, ver, formatVersion_1.AllegroFormatVersion.V_164);
    const unknown3 = readCondU16(stream, ver, formatVersion_1.AllegroFormatVersion.V_164);
    const strPtr = stream.readU32();
    const size = stream.readU32();
    const stringContent = stream.readStringFixed(size, true);
    const unknown4 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return { blockType: 0x1e, offset, type, t2, key, next, unknown2, unknown3, strPtr, size, stringContent, unknown4 };
}
function parseBlock0x1FPadstackDim(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = stream.readU32();
    const unknown4 = stream.readU32();
    const unknown5 = stream.readU16();
    const size = stream.readU16();
    let substructSize = 0;
    if (ver >= formatVersion_1.AllegroFormatVersion.V_175) {
        substructSize = size * 384 + 8;
    }
    else if (ver >= formatVersion_1.AllegroFormatVersion.V_172) {
        substructSize = size * 280 + 8;
    }
    else if (ver >= formatVersion_1.AllegroFormatVersion.V_162) {
        substructSize = size * 280 + 4;
    }
    else {
        substructSize = size * 240 + 4;
    }
    const substruct = Array.from(stream.readBytes(substructSize));
    return { blockType: 0x1f, offset, key, next, unknown2, unknown3, unknown4, unknown5, size, substruct };
}
function parseBlock0x20Unknown(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknownArray1 = stream.readArrayU32(7);
    const unknownArray2 = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174, 10);
    return { blockType: 0x20, offset, type, r, key, next, unknownArray1, unknownArray2 };
}
function parseBlock0x21Blob(stream, _ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const size = stream.readU32();
    if (size < 12) {
        throw new Error(`Block 0x21 size ${size} too small (minimum 12) at offset 0x${stream.position().toString(16)}`);
    }
    const key = stream.readU32();
    const nBytes = size - 12;
    const data = stream.readBytes(nBytes);
    return { blockType: 0x21, offset, type, r, size, key, data };
}
function parseBlock0x22Unknown(stream, ver, offset) {
    const type = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    const unknownArray = stream.readArrayU32(8);
    return { blockType: 0x22, offset, type, t2, key, unknown1, unknownArray };
}
function parseBlock0x23Ratline(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const flags = [stream.readU32(), stream.readU32()];
    const ptr1 = stream.readU32();
    const ptr2 = stream.readU32();
    const ptr3 = stream.readU32();
    const coords = stream.readArrayS32(5);
    const unknown1 = stream.readArrayU32(4);
    const unknown2 = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_164, 4);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return {
        blockType: 0x23,
        offset,
        type,
        layer,
        key,
        next,
        flags,
        ptr1,
        ptr2,
        ptr3,
        coords,
        unknown1,
        unknown2,
        unknown3,
    };
}
function parseBlock0x24Rect(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const parent = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coords = stream.readArrayS32(4);
    const ptr2 = stream.readU32();
    const unknown3 = stream.readU32();
    const unknown4 = stream.readU32();
    const unknown5 = stream.readU32();
    return {
        blockType: 0x24,
        offset,
        type,
        layer,
        key,
        next,
        parent,
        unknown1,
        unknown2,
        coords,
        ptr2,
        unknown3,
        unknown4,
        unknown5,
    };
}
function parseBlock0x26MatchGroup(stream, ver, offset) {
    const type = stream.readU8();
    const r = stream.readU16();
    const key = stream.readU32();
    const memberPtr = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const groupPtr = stream.readU32();
    const constPtr = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x26, offset, type, r, key, memberPtr, unknown1, groupPtr, constPtr, unknown2 };
}
function parseBlock0x27CstrmgrXref(stream, _ver, offset, endOff) {
    const totalBytes = endOff - 1 - stream.position();
    const kPadding = 3;
    if (totalBytes <= kPadding) {
        stream.skip(totalBytes);
        return { blockType: 0x27, offset, refs: [] };
    }
    stream.skip(kPadding);
    const payloadBytes = totalBytes - kPadding;
    const numValues = Math.floor(payloadBytes / 4);
    const remainder = payloadBytes % 4;
    const refs = [];
    for (let i = 0; i < numValues; i++) {
        refs.push(stream.readU32());
    }
    if (remainder > 0) {
        stream.skip(remainder);
    }
    return { blockType: 0x27, offset, refs };
}
function parseBlock0x28Shape(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const ptr1 = stream.readU32();
    const unknown1 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const ptr2 = stream.readU32();
    const ptr3 = stream.readU32();
    const ptr4 = stream.readU32();
    const firstSegmentPtr = stream.readU32();
    const unknown4 = stream.readU32();
    const unknown5 = stream.readU32();
    const ptr7 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const ptr6 = stream.readU32();
    const ptr7_16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coords = stream.readArrayS32(4);
    return {
        blockType: 0x28,
        offset,
        type,
        layer,
        key,
        next,
        ptr1,
        unknown1,
        unknown2,
        unknown3,
        ptr2,
        ptr3,
        ptr4,
        firstSegmentPtr,
        unknown4,
        unknown5,
        ptr7,
        ptr6,
        ptr7_16x,
        coords,
    };
}
function parseBlock0x29Pin(stream, _ver, offset) {
    const type = stream.readU8();
    const t = stream.readU16();
    const key = stream.readU32();
    const ptr1 = stream.readU32();
    const ptr2 = stream.readU32();
    const nullVal = stream.readU32();
    const ptr3 = stream.readU32();
    const coord1 = stream.readS32();
    const coord2 = stream.readS32();
    const ptrPadstack = stream.readU32();
    const unknown1 = stream.readU32();
    const ptrX30 = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = stream.readU32();
    const unknown4 = stream.readU32();
    return {
        blockType: 0x29,
        offset,
        type,
        t,
        key,
        ptr1,
        ptr2,
        nullVal,
        ptr3,
        coord1,
        coord2,
        ptrPadstack,
        unknown1,
        ptrX30,
        unknown2,
        unknown3,
        unknown4,
    };
}
function parseBlock0x2ALayerList(stream, ver, offset) {
    stream.skip(1);
    const numEntries = stream.readU16();
    const unknown = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    let nonRefEntries;
    let refEntries;
    if (ver < formatVersion_1.AllegroFormatVersion.V_165) {
        nonRefEntries = [];
        for (let i = 0; i < numEntries; i++) {
            const name = stream.readStringFixed(32, true);
            nonRefEntries.push({ name });
        }
    }
    else {
        refEntries = [];
        for (let i = 0; i < numEntries; i++) {
            const layerNameId = stream.readU32();
            const properties = stream.readU32();
            const unknownVal = stream.readU32();
            refEntries.push({ layerNameId, properties, unknown: unknownVal });
        }
    }
    const key = stream.readU32();
    return { blockType: 0x2a, offset, numEntries, unknown, nonRefEntries, refEntries, key };
}
function parseBlock0x2BFootprintDef(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const fpStrRef = stream.readU32();
    const unknown1 = stream.readU32();
    const coords = stream.readArrayU32(4);
    const next = stream.readU32();
    const firstInstPtr = stream.readU32();
    const unknownPtr3 = stream.readU32();
    const unknownPtr4 = stream.readU32();
    const unknownPtr5 = stream.readU32();
    const symLibPathPtr = stream.readU32();
    const unknownPtr6 = stream.readU32();
    const unknownPtr7 = stream.readU32();
    const unknownPtr8 = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_164);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x2b,
        offset,
        key,
        fpStrRef,
        unknown1,
        coords,
        next,
        firstInstPtr,
        unknownPtr3,
        unknownPtr4,
        unknownPtr5,
        symLibPathPtr,
        unknownPtr6,
        unknownPtr7,
        unknownPtr8,
        unknown2,
        unknown3,
    };
}
function parseBlock0x2CTable(stream, ver, offset) {
    const type = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const stringPtr = stream.readU32();
    const unknown4 = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const ptr1 = stream.readU32();
    const ptr2 = stream.readU32();
    const ptr3 = stream.readU32();
    const flags = stream.readU32();
    return {
        blockType: 0x2c,
        offset,
        type,
        t2,
        key,
        next,
        unknown1,
        unknown2,
        unknown3,
        stringPtr,
        unknown4,
        ptr1,
        ptr2,
        ptr3,
        flags,
    };
}
function parseBlock0x2DFootprintInst(stream, ver, offset) {
    const unknownByte1 = stream.readU8();
    const layer = stream.readU8();
    const unknownByte2 = stream.readU8();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const instRef16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown2 = stream.readU16();
    const unknown3 = stream.readU16();
    const unknown4 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const flags = stream.readU32();
    const rotation = stream.readU32();
    const coordX = stream.readS32();
    const coordY = stream.readS32();
    const instRef = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const graphicPtr = stream.readU32();
    const firstPadPtr = stream.readU32();
    const textPtr = stream.readU32();
    const unknownPtrs1 = stream.readArrayU32(4);
    return {
        blockType: 0x2d,
        offset,
        unknownByte1,
        layer,
        unknownByte2,
        key,
        next,
        unknown1,
        instRef16x,
        unknown2,
        unknown3,
        unknown4,
        flags,
        rotation,
        coordX,
        coordY,
        instRef,
        graphicPtr,
        firstPadPtr,
        textPtr,
        unknownPtrs1,
    };
}
function parseBlock0x2EConnection(stream, ver, offset) {
    const type = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const netAssignment = stream.readU32();
    const unknown1 = stream.readU32();
    const coordX = stream.readS32();
    const coordY = stream.readS32();
    const connection = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x2e,
        offset,
        type,
        t2,
        key,
        next,
        netAssignment,
        unknown1,
        coordX,
        coordY,
        connection,
        unknown2,
        unknown3,
    };
}
function parseBlock0x2FUnknown(stream, _ver, offset) {
    const type = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const unknownArray = stream.readArrayU32(6);
    return { blockType: 0x2f, offset, type, t2, key, unknownArray };
}
function parseBlock0x30StrWrapper(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const font = (0, blockStructs_1.condExists)(ver, formatVersion_1.AllegroFormatVersion.V_172) ? readTextProps(stream) : undefined;
    const ptr1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    const strGraphicPtr = stream.readU32();
    const unknown4 = stream.readU32();
    const font16x = (0, blockStructs_1.condExistsLt)(ver, formatVersion_1.AllegroFormatVersion.V_172) ? readTextProps(stream) : undefined;
    const ptr2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coordsX = stream.readU32();
    const coordsY = stream.readU32();
    const unknown5 = stream.readU32();
    const rotation = stream.readU32();
    const ptr3_16x = readCondU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    return {
        blockType: 0x30,
        offset,
        type,
        layer,
        key,
        next,
        unknown1,
        unknown2,
        font,
        ptr1,
        unknown3,
        strGraphicPtr,
        unknown4,
        font16x,
        ptr2,
        coordsX,
        coordsY,
        unknown5,
        rotation,
        ptr3_16x,
    };
}
function parseBlock0x31Sgraphic(stream, ver, offset) {
    const t = stream.readU8();
    const layerVal = stream.readU16();
    let stringLayer;
    switch (layerVal) {
        case 0xf001:
            stringLayer = blockStructs_1.StringLayer.BOT_TEXT;
            break;
        case 0xf101:
            stringLayer = blockStructs_1.StringLayer.TOP_TEXT;
            break;
        case 0xf609:
            stringLayer = blockStructs_1.StringLayer.BOT_PIN;
            break;
        case 0xf709:
            stringLayer = blockStructs_1.StringLayer.TOP_PIN;
            break;
        case 0xf801:
            stringLayer = blockStructs_1.StringLayer.TOP_PIN_LABEL;
            break;
        case 0xfa0d:
            stringLayer = blockStructs_1.StringLayer.BOT_REFDES;
            break;
        case 0xfb0d:
            stringLayer = blockStructs_1.StringLayer.TOP_REFDES;
            break;
        default:
            stringLayer = blockStructs_1.StringLayer.UNKNOWN;
            break;
    }
    const key = stream.readU32();
    const strGraphicWrapperPtr = stream.readU32();
    const coordsX = stream.readU32();
    const coordsY = stream.readU32();
    const unknown = stream.readU16();
    const len = stream.readU16();
    const un2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    const value = stream.readStringFixed(len, true);
    return {
        blockType: 0x31,
        offset,
        t,
        stringLayer,
        key,
        strGraphicWrapperPtr,
        coordsX,
        coordsY,
        unknown,
        len,
        un2,
        value,
    };
}
function parseBlock0x32PlacedPad(stream, ver, offset) {
    const type = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const netPtr = stream.readU32();
    const flags = stream.readU32();
    const prev = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const nextInFp = stream.readU32();
    const parentFp = stream.readU32();
    const track = stream.readU32();
    const padPtr = stream.readU32();
    const ptr6 = stream.readU32();
    const ratline = stream.readU32();
    const ptrPinNumber = stream.readU32();
    const nextInCompInst = stream.readU32();
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const nameText = stream.readU32();
    const ptr11 = stream.readU32();
    const coords = stream.readArrayS32(4);
    return {
        blockType: 0x32,
        offset,
        type,
        layer,
        key,
        next,
        netPtr,
        flags,
        prev,
        nextInFp,
        parentFp,
        track,
        padPtr,
        ptr6,
        ratline,
        ptrPinNumber,
        nextInCompInst,
        unknown2,
        nameText,
        ptr11,
        coords,
    };
}
function parseBlock0x33Via(stream, ver, offset) {
    stream.skip(1);
    const layerInfo = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const netPtr = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const unknownPtr1 = stream.readU32();
    const unknownPtr2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const coordsX = stream.readS32();
    const coordsY = stream.readS32();
    const connection = stream.readU32();
    const padstack = stream.readU32();
    const unknownPtr5 = stream.readU32();
    const unknownPtr6 = stream.readU32();
    const unknown4 = stream.readU32();
    const unknown5 = stream.readU32();
    const boundingBoxCoords = stream.readArrayS32(4);
    return {
        blockType: 0x33,
        offset,
        layerInfo,
        key,
        next,
        netPtr,
        unknown2,
        unknown3,
        unknownPtr1,
        unknownPtr2,
        coordsX,
        coordsY,
        connection,
        padstack,
        unknownPtr5,
        unknownPtr6,
        unknown4,
        unknown5,
        boundingBoxCoords,
    };
}
function parseBlock0x34Keepout(stream, ver, offset) {
    const t = stream.readU8();
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const ptr1 = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const flags = stream.readU32();
    const ptr2 = stream.readU32();
    const ptr3 = stream.readU32();
    const unknown2 = stream.readU32();
    return { blockType: 0x34, offset, t, layer, key, next, ptr1, unknown1, flags, ptr2, ptr3, unknown2 };
}
function parseBlock0x35FileRef(stream, _ver, offset) {
    const t2 = stream.readU8();
    const t3 = stream.readU16();
    const content = stream.readBytes(120);
    return { blockType: 0x35, offset, t2, t3, content };
}
function parseBlock0x36DefTable(stream, ver, offset) {
    stream.skip(1);
    const code = stream.readU16();
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const numItems = stream.readU32();
    const count = stream.readU32();
    const lastIdx = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    if (numItems > 1000000) {
        throw new Error(`Block 0x36 item count ${numItems} exceeds limit at offset 0x${stream.position().toString(16)}`);
    }
    const items = [];
    for (let i = 0; i < numItems; i++) {
        switch (code) {
            case 0x02: {
                const stringVal = stream.readStringFixed(32, true);
                const xs = stream.readArrayU32(14);
                const ys = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_164, 3);
                const zs = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172, 2);
                items.push({ type: "X02", stringVal, xs, ys, zs });
                break;
            }
            case 0x03: {
                let str;
                let str16x;
                if (ver >= formatVersion_1.AllegroFormatVersion.V_172) {
                    str = stream.readStringFixed(64, true);
                }
                else {
                    str16x = stream.readStringFixed(32, true);
                }
                const itemUnknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
                items.push({ type: "X03", str, str16x, unknown1: itemUnknown1 });
                break;
            }
            case 0x05: {
                const unknownBytes = Array.from(stream.readBytes(28));
                items.push({ type: "X05", unknown: unknownBytes });
                break;
            }
            case 0x06: {
                const itemN = stream.readU16();
                const itemR = stream.readU8();
                const s = stream.readU8();
                const itemUnknown1 = stream.readU32();
                const itemUnknown2 = readCondArrayU32Lt(stream, ver, formatVersion_1.AllegroFormatVersion.V_172, 50);
                items.push({
                    type: "X06",
                    n: itemN,
                    r: itemR,
                    s,
                    unknown1: itemUnknown1,
                    unknown2: itemUnknown2,
                });
                break;
            }
            case 0x08: {
                const a = stream.readU32();
                const b = stream.readU32();
                const charHeight = stream.readU32();
                const charWidth = stream.readU32();
                const fontUnknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
                const xs = stream.readArrayU32(4);
                const ys = readCondArrayU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172, 8);
                items.push({
                    type: "FontDef",
                    a,
                    b,
                    charHeight,
                    charWidth,
                    unknown2: fontUnknown2,
                    xs,
                    ys,
                });
                break;
            }
            case 0x0b: {
                const unknownBytes = Array.from(stream.readBytes(1016));
                items.push({ type: "X0B", unknown: unknownBytes });
                break;
            }
            case 0x0c: {
                const unknownBytes = Array.from(stream.readBytes(232));
                items.push({ type: "X0C", unknown: unknownBytes });
                break;
            }
            case 0x0d: {
                const unknownBytes = Array.from(stream.readBytes(200));
                items.push({ type: "X0D", unknown: unknownBytes });
                break;
            }
            case 0x0f: {
                const itemKey = stream.readU32();
                const ptrs = stream.readArrayU32(3);
                const itemPtr2 = stream.readU32();
                items.push({ type: "X0F", key: itemKey, ptrs, ptr2: itemPtr2 });
                break;
            }
            case 0x10: {
                const unknownBytes = Array.from(stream.readBytes(108));
                items.push({ type: "X10", unknown: unknownBytes });
                break;
            }
            default:
                throw new Error(`Unknown substruct type 0x${code.toString(16)} in block 0x36`);
        }
    }
    return { blockType: 0x36, offset, code, key, next, unknown1, numItems, count, lastIdx, unknown2, unknown3, items };
}
function parseBlock0x37PtrArray(stream, ver, offset) {
    const t = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const ptr1 = stream.readU32();
    const unknown1 = stream.readU32();
    const capacity = stream.readU32();
    const count = stream.readU32();
    const unknown2 = stream.readU32();
    const ptrs = stream.readArrayU32(100);
    const unknownArr = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x37, offset, t, t2, key, ptr1, unknown1, capacity, count, unknown2, ptrs, unknownArr };
}
function parseBlock0x38Film(stream, ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const next = stream.readU32();
    const layerList = stream.readU32();
    let filmName;
    if ((0, blockStructs_1.condExistsLt)(ver, formatVersion_1.AllegroFormatVersion.V_166)) {
        filmName = stream.readStringFixed(20, true);
    }
    const layerNameStr = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_166);
    const unknown2 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_166);
    const unknownArray1 = stream.readArrayU32(7);
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x38, offset, key, next, layerList, filmName, layerNameStr, unknown2, unknownArray1, unknown3 };
}
function parseBlock0x39FilmLayerList(stream, _ver, offset) {
    stream.skip(3);
    const key = stream.readU32();
    const parent = stream.readU32();
    const head = stream.readU32();
    const x = stream.readArrayU16(22);
    return { blockType: 0x39, offset, key, parent, head, x };
}
function parseBlock0x3AFilmListNode(stream, ver, offset) {
    stream.skip(1);
    const layer = readLayerInfo(stream);
    const key = stream.readU32();
    const next = stream.readU32();
    const unknown = stream.readU32();
    const unknown1 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    return { blockType: 0x3a, offset, layer, key, next, unknown, unknown1 };
}
function parseBlock0x3BProperty(stream, ver, offset) {
    const t = stream.readU8();
    const subType = stream.readU16();
    const len = stream.readU32();
    const name = stream.readStringFixed(128, true);
    const typeStr = stream.readStringFixed(32, true);
    const unknown1 = stream.readU32();
    const unknown2 = stream.readU32();
    const unknown3 = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_172);
    const value = stream.readStringFixed(len, true);
    return { blockType: 0x3b, offset, t, subType, len, name, typeStr, unknown1, unknown2, unknown3, value };
}
function parseBlock0x3CKeyList(stream, ver, offset) {
    const t = stream.readU8();
    const t2 = stream.readU16();
    const key = stream.readU32();
    const unknown = readCondU32(stream, ver, formatVersion_1.AllegroFormatVersion.V_174);
    const numEntries = stream.readU32();
    if (numEntries > 1000000) {
        throw new Error(`Block 0x3C entry count ${numEntries} exceeds limit at offset 0x${stream.position().toString(16)}`);
    }
    const entries = [];
    for (let i = 0; i < numEntries; i++) {
        entries.push(stream.readU32());
    }
    return { blockType: 0x3c, offset, t, t2, key, unknown, numEntries, entries };
}
function parseAllegroHeader(stream) {
    const magic = stream.readU32();
    const formatVersion = (0, formatVersion_1.formatVersionFromMagic)(magic);
    const unknown1 = stream.readArrayU32(4);
    const objectCount = stream.readU32();
    const unknown2 = stream.readArrayU32(9);
    let llV18_1;
    let llV18_2;
    let llV18_3;
    let llV18_4;
    let llV18_5;
    if (formatVersion >= formatVersion_1.AllegroFormatVersion.V_180) {
        llV18_1 = readLL(stream, formatVersion);
        llV18_2 = readLL(stream, formatVersion);
        llV18_3 = readLL(stream, formatVersion);
        llV18_4 = readLL(stream, formatVersion);
        llV18_5 = readLL(stream, formatVersion);
    }
    const ll0x04 = readLL(stream, formatVersion);
    const ll0x06 = readLL(stream, formatVersion);
    const ll0x0C = readLL(stream, formatVersion);
    const llShapes = readLL(stream, formatVersion);
    const ll0x14 = readLL(stream, formatVersion);
    const ll0x1BNets = readLL(stream, formatVersion);
    const ll0x1C = readLL(stream, formatVersion);
    const ll0x24_0x28 = readLL(stream, formatVersion);
    const llUnknown1 = readLL(stream, formatVersion);
    const ll0x2B = readLL(stream, formatVersion);
    const ll0x03_0x30 = readLL(stream, formatVersion);
    const ll0x0A = readLL(stream, formatVersion);
    const ll0x1D_0x1E_0x1F = readLL(stream, formatVersion);
    const llUnknown2 = readLL(stream, formatVersion);
    const ll0x38 = readLL(stream, formatVersion);
    const ll0x2C = readLL(stream, formatVersion);
    const ll0x0C_2 = readLL(stream, formatVersion);
    const llUnknown3 = readLL(stream, formatVersion);
    let x35Start;
    let x35End;
    let x27End;
    let stringsCount;
    let llUnknown5;
    let ll0x36;
    let llUnknown6;
    let ll0x0A_2;
    let llV18_6;
    if (formatVersion >= formatVersion_1.AllegroFormatVersion.V_180) {
        llUnknown5 = readLL(stream, formatVersion);
        ll0x36 = readLL(stream, formatVersion);
        llUnknown6 = readLL(stream, formatVersion);
        ll0x0A_2 = readLL(stream, formatVersion);
        llV18_6 = readLL(stream, formatVersion);
        x35Start = stream.readU32();
        x35End = stream.readU32();
        x27End = unknown2[4] ?? 0;
        stringsCount = unknown2[7] ?? 0;
    }
    else {
        x35Start = stream.readU32();
        x35End = stream.readU32();
        ll0x36 = readLL(stream);
        llUnknown5 = readLL(stream);
        llUnknown6 = readLL(stream);
        ll0x0A_2 = readLL(stream);
        stream.readU32();
        x27End = 0;
        stringsCount = 0;
    }
    const allegroVersion = stream.readStringFixed(60, true);
    const unknown4 = stream.readU32();
    const maxKey = stream.readU32();
    if (formatVersion >= formatVersion_1.AllegroFormatVersion.V_180) {
        stream.skipU32(9);
    }
    else {
        stream.skipU32(17);
    }
    const unitsVal = stream.readU8();
    let boardUnits;
    if (unitsVal === blockStructs_1.AllegroBoardUnits.IMPERIAL || unitsVal === blockStructs_1.AllegroBoardUnits.METRIC) {
        boardUnits = unitsVal;
    }
    else {
        throw new Error(`Unknown board units ${unitsVal}`);
    }
    stream.skip(3);
    const unknown6 = stream.readU32();
    if (formatVersion < formatVersion_1.AllegroFormatVersion.V_180) {
        stream.readU32();
        x27End = stream.readU32();
    }
    const unknown8 = stream.readU32();
    if (formatVersion < formatVersion_1.AllegroFormatVersion.V_180) {
        stringsCount = stream.readU32();
    }
    stream.readArrayU32(53);
    const unitsDivisor = stream.readU32();
    stream.skipU32(110);
    const layerMap = [];
    for (let i = 0; i < 25; i++) {
        const a = stream.readU32();
        const layerList0x2A = stream.readU32();
        layerMap.push({ a, layerList0x2A });
    }
    return {
        header: {
            magic,
            unknown1,
            objectCount,
            unknown2,
            linkedLists: {
                ll0x04,
                ll0x06,
                ll0x0C,
                llShapes,
                ll0x14,
                ll0x1BNets,
                ll0x1C,
                ll0x24_0x28,
                llUnknown1,
                ll0x2B,
                ll0x03_0x30,
                ll0x0A,
                ll0x1D_0x1E_0x1F,
                llUnknown2,
                ll0x38,
                ll0x2C,
                ll0x0C_2,
                llUnknown3,
                ll0x36,
                llUnknown5,
                llUnknown6,
                ll0x0A_2,
                llV18_1,
                llV18_2,
                llV18_3,
                llV18_4,
                llV18_5,
                llV18_6,
            },
            x35Start,
            x35End,
            x27End,
            stringsCount,
            allegroVersion,
            unknown4,
            maxKey,
            boardUnits,
            unknown6,
            unknown8,
            unitsDivisor,
            layerMap,
        },
        formatVersion,
    };
}
function readStringMap(stream, count) {
    stream.seek(blockStructs_1.STRING_TABLE_OFFSET);
    const table = {};
    for (let i = 0; i < count; i++) {
        const id = stream.readU32();
        const str = stream.readString(true);
        table[id] = str;
    }
    return table;
}
function parseAllegroFile(buffer) {
    const stream = new stream_1.AllegroStream(buffer);
    const { header, formatVersion } = parseAllegroHeader(stream);
    if (formatVersion === formatVersion_1.AllegroFormatVersion.V_PRE_V16) {
        throw new Error(`This file was created with ${header.allegroVersion.trim()}, which uses a binary format that ` +
            "predates Allegro 16.0 and is not supported by this importer. " +
            "To import this design, open it in Cadence Allegro PCB Editor version 16.0 or later and re-save.");
    }
    const stringTable = readStringMap(stream, header.stringsCount);
    const blocks = readObjects(stream, formatVersion, header.x27End);
    return { header, formatVersion, blocks, stringTable };
}
function skipZeroPadding(stream) {
    let scanPos = stream.position();
    let nextByte = stream.tryReadU8();
    while (nextByte !== undefined && nextByte === 0x00) {
        scanPos = stream.position();
        nextByte = stream.tryReadU8();
    }
    if (nextByte !== undefined && nextByte > 0x00 && nextByte <= 0x3c) {
        let blockStart = scanPos;
        if (blockStart % 4 !== 0) {
            blockStart -= blockStart % 4;
        }
        stream.seek(blockStart);
        const alignedByte = stream.tryReadU8();
        stream.seek(blockStart);
        if (alignedByte !== undefined && alignedByte > 0x00 && alignedByte <= 0x3c) {
            return true;
        }
    }
    return false;
}
function readObjects(stream, ver, x27End) {
    const blocks = [];
    // Align to 4-byte boundary after string table
    const pos = stream.position();
    if (pos % 4 !== 0) {
        stream.seek(pos + (4 - (pos % 4)));
    }
    // Skip initial zero-padding between string table and first block
    if (stream.hasMore()) {
        const peekByte = stream.tryReadU8();
        if (peekByte === 0x00) {
            if (!skipZeroPadding(stream)) {
                return blocks;
            }
        }
        else if (peekByte !== undefined) {
            stream.seek(stream.position() - 1);
        }
    }
    while (stream.hasMore()) {
        const offset = stream.position();
        const blockTypeByte = stream.tryReadU8();
        if (blockTypeByte === undefined) {
            break;
        }
        if (blockTypeByte === 0x00) {
            if (ver >= formatVersion_1.AllegroFormatVersion.V_180) {
                // V18 files can have zero-padded gaps between block groups
                if (skipZeroPadding(stream)) {
                    continue;
                }
            }
            break;
        }
        stream.seek(offset);
        const block = parseBlock(stream, ver, x27End);
        if (block !== undefined) {
            blocks.push(block);
        }
        else {
            break;
        }
    }
    return blocks;
}
const BLOCK_DISPATCH = {
    0x01: parseBlock0x01Arc,
    0x03: parseBlock0x03Field,
    0x04: parseBlock0x04NetAssignment,
    0x05: parseBlock0x05Track,
    0x06: parseBlock0x06Component,
    0x07: parseBlock0x07ComponentInst,
    0x08: parseBlock0x08PinNumber,
    0x09: parseBlock0x09FillLink,
    0x0a: parseBlock0x0ADrc,
    0x0c: parseBlock0x0CPinDef,
    0x0d: parseBlock0x0DPad,
    0x0e: parseBlock0x0EShapeSeg,
    0x0f: parseBlock0x0FFunctionSlot,
    0x10: parseBlock0x10FunctionInst,
    0x11: parseBlock0x11PinName,
    0x12: parseBlock0x12Xref,
    0x14: parseBlock0x14Graphic,
    0x1b: parseBlock0x1BNet,
    0x1c: parseBlock0x1CPadstack,
    0x1d: parseBlock0x1DConstraintSet,
    0x1e: parseBlock0x1ESiModel,
    0x1f: parseBlock0x1FPadstackDim,
    0x20: parseBlock0x20Unknown,
    0x21: parseBlock0x21Blob,
    0x22: parseBlock0x22Unknown,
    0x23: parseBlock0x23Ratline,
    0x24: parseBlock0x24Rect,
    0x26: parseBlock0x26MatchGroup,
    0x28: parseBlock0x28Shape,
    0x29: parseBlock0x29Pin,
    0x2a: parseBlock0x2ALayerList,
    0x2b: parseBlock0x2BFootprintDef,
    0x2c: parseBlock0x2CTable,
    0x2d: parseBlock0x2DFootprintInst,
    0x2e: parseBlock0x2EConnection,
    0x2f: parseBlock0x2FUnknown,
    0x30: parseBlock0x30StrWrapper,
    0x31: parseBlock0x31Sgraphic,
    0x32: parseBlock0x32PlacedPad,
    0x33: parseBlock0x33Via,
    0x34: parseBlock0x34Keepout,
    0x35: parseBlock0x35FileRef,
    0x36: parseBlock0x36DefTable,
    0x37: parseBlock0x37PtrArray,
    0x38: parseBlock0x38Film,
    0x39: parseBlock0x39FilmLayerList,
    0x3a: parseBlock0x3AFilmListNode,
    0x3b: parseBlock0x3BProperty,
    0x3c: parseBlock0x3CKeyList,
};
function parseBlock(stream, ver, x27End) {
    const offset = stream.position();
    const blockType = stream.readU8();
    if (blockType >= 0x15 && blockType <= 0x17) {
        return parseBlock0x15_16_17Segment(stream, ver, offset, blockType);
    }
    if (blockType === 0x27) {
        if (x27End <= stream.position()) {
            throw new Error(`Current offset 0x${stream
                .position()
                .toString(16)} is at or past the expected end of block 0x27 at 0x${x27End.toString(16)}`);
        }
        return parseBlock0x27CstrmgrXref(stream, ver, offset, x27End);
    }
    const handler = BLOCK_DISPATCH[blockType];
    if (handler) {
        return handler(stream, ver, offset);
    }
    return undefined;
}
//# sourceMappingURL=parser.js.map